module.exports = __webpack_public_path__ + "static/media/synthetix.3726c7df.svg";